import React from "react";
import { Grid } from "@mui/material";

const SubmitButton = ({ buttonLoading }) => {
  return (
    <Grid item xs={12} display="flex" justifyContent="end">
      <button className="btn-new-design-black" disabled={buttonLoading} type="submit">
        {buttonLoading ? "Loading..." : "Update"}
      </button>
    </Grid>
  );
};

export default SubmitButton;
